import { i18n } from 'app/utils/i18n';

import './SearchInput.scss';

interface SearchInputProps {
  searchInput: string;
  setSearchInput: (value: string) => void;
}

export const SearchInput = ({ searchInput, setSearchInput }: SearchInputProps) => {
  return (
    <div className="custom__search-wrapper">
      <input
        id="search-input"
        type="text"
        className="custom__search-input"
        placeholder={i18n('tag.search.placeholder')}
        value={searchInput}
        onChange={(e) => setSearchInput(e.target.value)}
      />

      <span className="custom__search-icon">
        <i className="fa fa-search" />
      </span>
    </div>
  );
};
